export function createCustomer(data) {
    return new Promise((resolve, reject) => {
		let { createCustomerRequest, createCustomerError, createCustomerResult } = this.props;

        delete data.creationDate;
        delete data.updateDate;

		this.doAction(
			this.WEB_REQUEST_URL + 'create_customer',
			this.createBundle(
				'create_customer',
				{ customer: data },
				this.POST,
				createCustomerRequest,
                (result) => {
                    createCustomerResult(result)
                    resolve(result)
                },
                (error) => {
                    createCustomerError(error)
                    reject(error)
                }
			)
		);
	})
}
